import React, { Component } from "react";
import { connect } from "react-redux";
import CustomSelect from "../../components/common/select/Select";
import OutletMiddleware from "../../store/prat_middleware/gt/outletMiddleware";
import { openDB, } from 'idb';
import "./style/productDetail.scss";
import "./style/outlet.scss";
import Isoutlet from './validation/outletSection'
import CustomToast from '../../util-functions/customToast.jsx'

let outletData=[]
let channelData=[];
let productData=[];
let geoData=[];
let isSaveDraft=false;
let outletFlags = []
class Outlet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOutletProgram: [],
      selectedLocationType: [],
      selectedTier: [],
      selectedPerfectVillage: [],
      selectedChannelTts: [],
      selectedChainOutlets: [],
      selectedPerfectStore: [],
      selectedPerfectStoreCompliance: [],
      selectedOutleClassification: [],
      selectedRange: [],
      selectedPointOfConsumption: [],
      selectedLoyalityProgram: [],
      selectedCustomerAttribute: [],
      outlet_summaries: {},
      sync:false,
      isChannel:false,
      expanded:false,
      channelName:'',
      exludedOutletOpen:false,
      updatedOutletSummary:false,
      selectedExcludedOutlets:[],
      category:[],
      m_channel:'',
      isExtend:true,
      selectedAllOutletProgramFlag:null,
      selectedAllLocationTypeFlag:null,
      selectedAllTiersFlag:null,
      selectedAllPerfectVillageFlag:null,
      selectedAllChannelTtsFlag:false,
      selectedAllChainOutletsFlag:null,
      selectedAllPerfectStoreFlag:null,
      selectedAllPerfectStoreComplianceFlag:null,
      selectedAllOutletClassificationFlag:null,
      selectedAllRangeFlag:null,
      selectedAllPointOfConsumptionFlag:null,
      selectedAllLoyaltyProgramFlag:null,
      selectedAllCustomerAttributeFlag:null,
      channelTtsOptionCheck:[]
    };
  }
  componentDidMount() {
    const {
      get_outletProgram,
      get_tier,
      get_LocationType,
      get_perfectVillage,
      get_channelTts,
      get_chainOutlets,
      get_perfectStore,
      get_perfectStoreCompliance,
      get_outletClassification,
      get_range,
      get_pointOfConsumption,
      get_loyalityProgram,
      get_customerAttribute
    } = this.props;
    get_outletProgram();
    get_tier();
    get_LocationType();
    get_perfectVillage();
    get_channelTts();
    get_chainOutlets();
    get_perfectStore();
    get_perfectStoreCompliance();
    get_outletClassification();
    get_range();
    get_pointOfConsumption();
    get_loyalityProgram();
    get_customerAttribute();

  
  this.firstTimeData()  
  this.channelTTsCheckFunction()
  isSaveDraft=true
  }
firstTimeData(){
  // let finalarr =[]
  const getChannelData = async  () => {
    if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }
    const dbName = "gt_form";
    const storeName = "product_store";
    const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {
      
    });
    let data,tx,obj 
    data  =   await db
    tx  = await data.transaction(storeName)
        obj= await tx.objectStore(storeName)
          let outletRes = await obj.get('outlet_detail');
          let channelRes = await obj.get('channel_detail');
          let productRes = await obj.get('product_detail');
          let geoRes = await obj.get('geo_detail');
          let getOutletFlags = await obj.get('selectedAllOutletFlags');
  
      outletData=outletRes ? outletRes.value : []
      channelData=channelRes ? channelRes.value : []
      productData=productRes ? productRes.value : []
      geoData= geoRes ? geoRes.value : []

      outletFlags = getOutletFlags ? getOutletFlags.value : []
          
      outletData=outletData[0]?outletData[0]:outletData
      channelData=channelData[0]?channelData[0]:channelData
      productData=productData[0]?productData[0]:productData
      geoData = geoData[0] ? geoData[0] : geoData

      outletFlags = outletFlags[0] ? outletFlags[0] : outletFlags
      // if(outletData?.channel_tts?.length > 0){
      //   this.setState({selectedChannelTts:outletData?.channel_tts,category:productData.categories})              
      // }
       if(productData.length!==0){      
        if(productData.promotion_type === '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9'){
          let arr = this.state.selectedChannelTts;
          console.log(arr,arr.includes("6e89bf6c-73dd-47f3-b0d8-bd73c73aa774"),this.state.selectedChannelTts)
          if(arr.includes("6e89bf6c-73dd-47f3-b0d8-bd73c73aa774")){
            console.log('hello')
          }else{
            console.log('hi')
            arr.push("6e89bf6c-73dd-47f3-b0d8-bd73c73aa774")
            this.setState({selectedChannelTts:arr,category:productData.categories,channelTtsOptionCheck:arr})              
          }
        }
        else{
        if(productData.categories.length===0){
          let arr =this.state.selectedChannelTts;
          let is_other = arr.includes("82652578-87f4-462d-af65-effac29179af")
          is_other === false ? arr.push("82652578-87f4-462d-af65-effac29179af") : void 0
          // finalarr=arr
            this.setState({selectedChannelTts:arr,category:productData.categories,channelTtsOptionCheck:arr})              
        } else{
          
            productData.categories.forEach(is_category => {

              if(is_category === '748b1a5b-5eb3-412f-8b03-fa34aea6d71b' || 
              is_category === '040af7ec-5ca5-4740-b899-9dbc48167599' || is_category === 'd5b17924-d758-4f0d-b289-3c95177f10ff' ){
                let arr = this.state.selectedChannelTts;
                let is_other = arr.includes("82652578-87f4-462d-af65-effac29179af");
                let new_2 = arr.includes("72181de5-4330-4116-ad70-93004e20f14f");
                let new_3 = arr.includes("6578b19d-2d67-4ae1-a14b-d9eb1e35a7c1");
                

              //  arr.forEach(item =>{
                if(is_other === true && new_2 === false && new_3 === false){
                
                  arr.push("72181de5-4330-4116-ad70-93004e20f14f","6578b19d-2d67-4ae1-a14b-d9eb1e35a7c1" ,
                  )
                } else  if(is_other === false && new_2 === true && new_3 === false){
                
                  arr.push("82652578-87f4-462d-af65-effac29179af","6578b19d-2d67-4ae1-a14b-d9eb1e35a7c1" ,
                  )                         
                }  else  if(is_other === false && new_2 === false && new_3 === true){
                
                  arr.push("82652578-87f4-462d-af65-effac29179af","72181de5-4330-4116-ad70-93004e20f14f" ,
                  )
                } 
                else if(is_other === false && new_2 === false && new_3 === false){
                  arr.push("72181de5-4330-4116-ad70-93004e20f14f","6578b19d-2d67-4ae1-a14b-d9eb1e35a7c1" ,
                  "82652578-87f4-462d-af65-effac29179af")

                }
                
                    this.setState({selectedChannelTts:arr,category:productData.categories,channelTtsOptionCheck:arr})              
                }else{
                  let arr =this.state.selectedChannelTts;;
                  let is_other = arr.includes("82652578-87f4-462d-af65-effac29179af")
                  is_other === false ?
                  arr.push("82652578-87f4-462d-af65-effac29179af") : void 0;
                
                // finalarr=arr
                  this.setState({selectedChannelTts:arr,category:productData.categories,channelTtsOptionCheck:arr})              
              }
            })
          }
      }
      }
        if(channelData.length!==0&& productData?.promotion_type !== 'b0107ffd-5026-4011-bdc6-3bb2e5986332'){
          if(productData?.promotion_type === '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9'){

          }
          else{
          // let arr = this.state.selectedChannelTts;
          let is_Mt = channelData?.master_channels.includes("261ae803-0149-4083-9127-da216a08da83")
          // let is_super_market = arr.includes("6e89bf6c-73dd-47f3-b0d8-bd73c73aa774")
          if (channelData?.master_channels.length!==0 && is_Mt === true){
          this.setState({isChannel:true})
          let arr= this.state.selectedChannelTts;
          // let is_Mt = channelData.master_channels.includes("261ae803-0149-4083-9127-da216a08da83")
          // if(is_Mt == false &&  )
          // let last_index = channelData.master_channels.length-1
          channelData.master_channels.forEach((item,ind) => {
            if(item===  "261ae803-0149-4083-9127-da216a08da83"){
              arr.push("6e89bf6c-73dd-47f3-b0d8-bd73c73aa774")
                // finalarr=arr
                this.setState({m_channel:item,selectedChannelTts:arr,channelTtsOptionCheck:arr})                
            }
          
            
          })
        }
      }
      }   
      if(outletData.length!==0){
    
        isSaveDraft=true
        if(outletData.outet_programs){
          this.setState({selectedOutletProgram: outletData.outet_programs})
        }
      
      if(outletData.location_types){
        this.setState({selectedLocationType: outletData.location_types})
      }
      if(outletData.tiers){
        this.setState({selectedTier: outletData.tiers})
      }
      if(outletData.perfect_villages){
        this.setState({selectedPerfectVillage: outletData.perfect_villages})
      }
      if(outletData.channel_tts){
        // this.setState({selectedChannelTts: finalarr.length!==0 ? finalarr : outletData.channel_tts})
      }
      if(outletData.chain_outlets){
        this.setState({selectedChainOutlets: outletData.chain_outlets})
      }
      if(outletData.perfect_stores){
        this.setState({selectedPerfectStore: outletData.perfect_stores})
      }
      if(outletData.perfect_store_compliances){
        this.setState({selectedPerfectStoreCompliance: outletData.perfect_store_compliances})
      }
      if(outletData.outlet_classifications){
        this.setState({selectedOutleClassification: outletData.outlet_classifications})
      }
      if(outletData.ranges){
        this.setState({selectedRange: outletData.ranges})
      }
      if(outletData.point_of_consumptions){
        this.setState({selectedPointOfConsumption: outletData.point_of_consumptions})
      }
      if(outletData.loyalty_programs){
        this.setState({selectedLoyalityProgram: outletData.loyalty_programs})
      }
      if(outletData.customer_attributes){
        this.setState({selectedCustomerAttribute: outletData.customer_attributes})
      }
      if(outletData.excluded_outlets){
        this.setState({selectedExcludedOutlets: outletData.excluded_outlets})
      }

      if(outletFlags.outet_programs === true || outletFlags.outet_programs === false || outletFlags.outet_programs === null){
        this.setState({selectedAllOutletProgramFlag:outletFlags.outet_programs})
      }
      if(outletFlags.location_types === true || outletFlags.location_types === false || outletFlags.location_types === null){
        this.setState({selectedAllLocationTypeFlag:outletFlags.location_types})
      }
      if(outletFlags.tiers === true || outletFlags.tiers === false || outletFlags.tiers === null){
        this.setState({selectedAllTiersFlag:outletFlags.tiers})
      }
      if(outletFlags.perfect_villages === true || outletFlags.perfect_villages === false || outletFlags.perfect_villages === null){
        this.setState({selectedAllPerfectVillageFlag:outletFlags.perfect_villages})
      }
      if(outletFlags.channel_tts === true || outletFlags.channel_tts === false || outletFlags.channel_tts === null){
        this.setState({selectedAllChannelTtsFlag:outletFlags.channel_tts})
      }
      if(outletFlags.chain_outlets === true || outletFlags.chain_outlets === false || outletFlags.chain_outlets === null){
        this.setState({selectedAllChainOutletsFlag:outletFlags.chain_outlets})
      }
      if(outletFlags.perfect_stores === true || outletFlags.perfect_stores === false || outletFlags.perfect_stores === null){
        this.setState({selectedAllPerfectStoreFlag:outletFlags.perfect_stores})
      }
      if(outletFlags.perfect_store_compliances === true || outletFlags.perfect_store_compliances === false || outletFlags.perfect_store_compliances === null){
        this.setState({selectedAllPerfectStoreComplianceFlag:outletFlags.perfect_store_compliances})
      }
      if(outletFlags.outlet_classifications === true || outletFlags.outlet_classifications === false || outletFlags.outlet_classifications === null){
        this.setState({selectedAllOutletClassificationFlag:outletFlags.outlet_classifications})
      }
      if(outletFlags.ranges === true || outletFlags.ranges === false || outletFlags.ranges === null){
        this.setState({selectedAllRangeFlag:outletFlags.ranges})
      }
      if(outletFlags.point_of_consumptions === true || outletFlags.point_of_consumptions === false || outletFlags.point_of_consumptions === null){
        this.setState({selectedAllPointOfConsumptionFlag:outletFlags.point_of_consumptions})
      }
      if(outletFlags.loyalty_programs === true || outletFlags.loyalty_programs === false || outletFlags.loyalty_programs === null){
        this.setState({selectedAllLoyaltyProgramFlag:outletFlags.loyalty_programs})
      }
      if(outletFlags.customer_attributes === true || outletFlags.customer_attributes === false || outletFlags.customer_attributes === null){
        this.setState({selectedAllCustomerAttributeFlag:outletFlags.customer_attributes})
      }
      isSaveDraft=true
    }
    }

    getChannelData();
    isSaveDraft=true
  }

  saveOutletData(data,flag){
  const saveData = async  (data,flag) => {
    if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }

      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

       const db = await openDB(dbName, version, {
        upgrade(db, oldVersion, newVersion, transaction) {
          const store = db.createObjectStore(storeName);       // eslint-disable-line
        }
      });
      const tx = await db.transaction(storeName, "readwrite");
      const store = await tx.objectStore(storeName);

            const value = await store.put({"key":"outlet_123","value":data },"outlet_detail");       // eslint-disable-line
            const isSave = await store.put({"key":"draft_123","value":flag},"is_draft_saved")       // eslint-disable-line

        // }
        await tx.dones;                

          let resp; let txs;let obj;  
          resp  =   await db
          txs  = await resp.transaction(storeName)
          obj= await txs.objectStore(storeName)
          let outletDataRes = await obj.get('outlet_detail');
          let draft = await obj.get('is_draft_saved');
        outletData=outletDataRes ? outletDataRes.value : []   
        draft=draft?draft.value: []    
        this.props.call_back( this.props.draft_state===true?true:isSaveDraft===true?false: draft)

      }
      if(isSaveDraft===false){
        saveData(data,flag)
      }
      else{
        isSaveDraft=false
      }
    }

    setFlagDataInDb(data){
   
      const saveFlagData = async (data) => {
        if (!("indexedDB" in window)) {
          console.warn("IndexedDB not supported");
          return;
        }
    
        const dbName = "gt_form";
        const storeName = "product_store";
        const version = 1; //versions start at 1
    
        const db = await openDB(dbName, version, {
          upgrade(db, oldVersion, newVersion, transaction) {
            const store = db.createObjectStore(storeName);       // eslint-disable-line
          }
        });
        const tx = await db.transaction(storeName, "readwrite");
        const store = await tx.objectStore(storeName);     
        let value = undefined;       // eslint-disable-line
          value = await store.put({ "key": "sele_Out_123", "value": data }, "selectedAllOutletFlags");
          await tx.dones; 
      }
    
      saveFlagData(data)
    
    }

  getOutletData(){
    const getData = async  () => {
      if (!("indexedDB" in window)) {
          console.warn("IndexedDB not supported");
          return;
        }
        const dbName = "gt_form";
        const storeName = "product_store";
        const version = 1; //versions start at 1
  
          const db = await openDB(dbName, version, {
          
        });
          let result =   await db
                  .transaction(storeName)
                  .objectStore(storeName)
                  .get("outlet_detail");
      
          outletData=result ? result.value : []
        }
       
        getData() ;          
}

programChange=val=>{
  if(val===null || val.length === 0){
   
    this.setState({selectedOutletProgram:[],expanded:false},() => {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)
      this.setState({
        selectedAllOutletProgramFlag:null
      })
    })
  }
  else{
    let arr = []
    val.forEach(e => {
      arr.push(e.value)
    })  
    this.setState({selectedOutletProgram:arr,expanded:false}, () => {
      Isoutlet.isoutlet('program',this.state,this.props)
      this.setState({
        selectedAllOutletProgramFlag: this.state.selectedOutletProgram.length === 0 ? null : this.props.outletProgram?.length === this.state.selectedOutletProgram.length ? true : false
      })
    })
    }
}

locationChange=val=>{
  if(val===null || val.length===0){
    this.setState({selectedLocationType:[],expanded:false},() => {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)
      this.setState({
        selectedAllLocationTypeFlag: null
      })
    })
   
  } else{
    let arr = []
    val.forEach(e => {
      arr.push(e.value)
    })  
    this.setState({selectedLocationType:arr,expanded:false},() => {
      Isoutlet.isoutlet('location',this.state,this.props)
      this.setState({
        selectedAllLocationTypeFlag: this.state.selectedLocationType.length === 0 ? null : this.props.locationType.length === this.state.selectedLocationType.length ? true :false
      })
    })
    }
}

tierChange=val=>{
  if(val===null || val.length===0 ){
    this.setState({selectedTier:[],expanded:false},() => {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)
      this.setState({
        selectedAllTiersFlag: null
      })
    })
  
  }  else{
    let arr = []
    val.forEach(e => {
      arr.push(e.value)
    })  
    this.setState({selectedTier:arr,expanded:false},() => {
      Isoutlet.isoutlet('tier',this.state,this.props)
      this.setState({
        selectedAllTiersFlag: this.state.selectedTier.length === 0 ? null : this.props.tier.length === this.state.selectedTier.length
      })
    })
    }
}

villageChange=val=>{
 
  if(val!==null ){
    

    let arr = []
    val.forEach(e => {
      arr.push(e.value)
    })  
    this.setState({selectedPerfectVillage:arr,expanded:false},() => {
      Isoutlet.isoutlet('village',this.state,this.props)
      this.setState({
        selectedAllPerfectVillageFlag: this.state.selectedPerfectVillage.length === 0 ? null : this.props.perfectVillage.length === this.state.selectedPerfectVillage.length
      })
      
    })
  }  else{
    this.setState({selectedPerfectVillage:[],expanded:false},() => {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)
      this.setState({
        selectedAllPerfectVillageFlag: null
      })
    })
    } if( val&& val.length === 0) {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)

    }
}

channelTtsChannge=val=>{
  if(val!==null){
    let arr = []
    val.forEach(e => {
      arr.push(e.value)
    })  
    this.setState({selectedChannelTts:arr,expanded:false},() => {
      Isoutlet.isoutlet('channel_tts',this.state,this.props)
      this.setState({
        selectedAllChannelTtsFlag: this.state.selectedChannelTts.length === 0 ? null : this.state.selectedChannelTts.length === this.state.channelTtsOptionCheck.length ? true : false 
      })
    })
  } else{
    this.setState({selectedChannelTts:[],expanded:false},() => {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)
      this.setState({
        selectedAllChannelTtsFlag: null
      })
    })
  }
  if( val&& val.length === 0) {
    Isoutlet.isoutlet('onEmpty',this.state,this.props)

  }
}

chainOutletChange=val=>{
  if(val!==null){
    let arr = []
    val.forEach(e => {
      arr.push(e.value)
    })  
    this.setState({selectedChainOutlets:arr,expanded:false},() => {
      Isoutlet.isoutlet('chain_outlet',this.state,this.props)
      this.setState({
        selectedAllChainOutletsFlag: this.state.selectedChainOutlets.length === 0 ? null : this.props.chainOutlets.length === this.state.selectedChainOutlets.length ? true : false 
      })
    })
  } else{
    this.setState({selectedChainOutlets:[]},() => {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)
      this.setState({
        selectedAllChainOutletsFlag: null
      })
    })
  }
  if( val&& val.length === 0) {
    Isoutlet.isoutlet('onEmpty',this.state,this.props)

  }
}

storeChange=val=>{
  if(val!==null){
    let arr = []
    val.forEach(e => {
      arr.push(e.value)
    })  
    this.setState({selectedPerfectStore:arr,expanded:false},() => {
      Isoutlet.isoutlet('store',this.state,this.props)
      this.setState({
        selectedAllPerfectStoreFlag: this.state.selectedPerfectStore.length === 0 ? null : this.props.perfectStore.length === this.state.selectedPerfectStore.length ? true :false
      })
    })
  } else{
    this.setState({selectedPerfectStore:[],expanded:false},() => {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)
      this.setState({
        selectedAllPerfectStoreFlag: null
      })
    })
  }
  if( val&& val.length === 0) {
    Isoutlet.isoutlet('onEmpty',this.state,this.props)

  }
}

storeComplianceChange=val=>{
  if(val!==null){
    let arr = []
    val.forEach(e => {
      arr.push(e.value)
    })  
    this.setState({selectedPerfectStoreCompliance:arr,expanded:false},() => {
      Isoutlet.isoutlet('store_compliance',this.state,this.props)
      this.setState({
        selectedAllPerfectStoreComplianceFlag: this.state.selectedPerfectStoreCompliance.length === 0 ? null : this.props.perfectStoreCompliance.length === this.state.selectedPerfectStoreCompliance.length ? true : false
      })
    })
  } else{
    this.setState({selectedPerfectStoreCompliance:[],expanded:false},() => {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)
      this.setState({
        selectedAllPerfectStoreComplianceFlag: null
      })
    })
  }
  if( val&& val.length === 0) {
    Isoutlet.isoutlet('onEmpty',this.state,this.props)

  }
}

outletClassificationchange=val=>{
  if(val!==null){
    let arr = []
    val.forEach(e => {
      arr.push(e.value)
    })  
    this.setState({selectedOutleClassification:arr,expanded:false},() => {
      Isoutlet.isoutlet('outlet_classification',this.state,this.props)
      this.setState({
        selectedAllOutletClassificationFlag: this.state.selectedOutleClassification.length === 0 ? null : this.props.outletClassification.length === this.state.selectedOutleClassification.length ? true : false
      })
    })
  } else{
    this.setState({selectedOutleClassification:[],expanded:false},() => {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)
      this.setState({
        selectedAllOutletClassificationFlag: null
      })
    })
  }
  if( val&& val.length === 0) {
    Isoutlet.isoutlet('onEmpty',this.state,this.props)

  }
}

rangeChange=val=>{
  if(val!==null){
    let arr = []
    val.forEach(e => {
      arr.push(e.value)
    })  
    this.setState({selectedRange:arr,expanded:false},() => {
      Isoutlet.isoutlet('range',this.state,this.props)
      this.setState({
        selectedAllRangeFlag: this.state.selectedRange.length === 0 ? null : this.props.range.length === this.state.selectedRange.length ? true : false
      })
    })
  } else{
    this.setState({selectedRange:[],expanded:false},() => {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)
      this.setState({
        selectedAllRangeFlag: null
      })
    })
  }
  if( val&& val.length === 0) {
    Isoutlet.isoutlet('onEmpty',this.state,this.props)

  }
}

consumptionChange=val=>{
  if(val!==null){
    let arr = []
    val.forEach(e => {
      arr.push(e.value)
    })  
    this.setState({selectedPointOfConsumption:arr,expanded:false},() => {
      Isoutlet.isoutlet('consumption',this.state,this.props)
      this.setState({
        selectedAllPointOfConsumptionFlag: this.state.selectedPointOfConsumption.length === 0 ? null : this.props.pointOfConsumption.length === this.state.selectedPointOfConsumption.length ? true : false
      })
    })
  } else{
    this.setState({selectedPointOfConsumption:[],expanded:false},() => {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)
      this.setState({
        selectedAllPointOfConsumptionFlag: null
      })
    })
  }
  if( val&& val.length === 0) {
    Isoutlet.isoutlet('onEmpty',this.state,this.props)

  }
}

loyalityChange=val=>{
  if(val!==null){
    let arr = []
    val.forEach(e => {
      arr.push(e.value)
    })  
    this.setState({selectedLoyalityProgram:arr,expanded:false},() => {
      Isoutlet.isoutlet('loyality',this.state,this.props)
      this.setState({
        selectedAllLoyaltyProgramFlag: this.state.selectedLoyalityProgram.length === 0 ? null : this.props.loyalityProgram.length === this.state.selectedLoyalityProgram.length ? true : false
      })
    })
  } else{
    this.setState({selectedLoyalityProgram:[],expanded:false},() => {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)
      this.setState({
        selectedAllLoyaltyProgramFlag: null
      })
    })
  } if( val&& val.length === 0) {
    Isoutlet.isoutlet('onEmpty',this.state,this.props)

  }
}
customerAttributeChange=val=>{
  if(val!==null){
    let arr = []
    val.forEach(e => {
      arr.push(e.value)
    })  
    this.setState({selectedCustomerAttribute:arr,expanded:false},() => {
      Isoutlet.isoutlet('customer_attribute',this.state,this.props)
      this.setState({
        selectedAllCustomerAttributeFlag: this.state.selectedCustomerAttribute.length === 0 ? null : this.props.customerAttribute.length === this.state.selectedCustomerAttribute.length ? true : false
      })
    })
  } else{
    this.setState({selectedCustomerAttribute:[],expanded:false},() => {
      Isoutlet.isoutlet('onEmpty',this.state,this.props)
      this.setState({
        selectedAllCustomerAttributeFlag: null
      })
    })
  } if( val&& val.length === 0) {
    Isoutlet.isoutlet('onEmpty',this.state,this.props)

  }
}

channelTTsCheckFunction = () =>{


    // console.log( this.props.channelTts?this.props.channelTts.filter(for_cat => {
    //   return ((this.state.category.includes('748b1a5b-5eb3-412f-8b03-fa34aea6d71b') ||
    //   this.state.category.includes('040af7ec-5ca5-4740-b899-9dbc48167599') ||                
    //   this.state.category.includes('d5b17924-d758-4f0d-b289-3c95177f10ff')) ?
    //   (for_cat.guid === "72181de5-4330-4116-ad70-93004e20f14f" ||                
    //   for_cat.guid === "6578b19d-2d67-4ae1-a14b-d9eb1e35a7c1" ||
    //   for_cat.guid === "82652578-87f4-462d-af65-effac29179af") : (
    //     for_cat.guid === "82652578-87f4-462d-af65-effac29179af"
    //   ) ||
    //   this.state.m_channel === '261ae803-0149-4083-9127-da216a08da83' && 
    //   for_cat.guid === "6e89bf6c-73dd-47f3-b0d8-bd73c73aa774" )
    //   }).map(item => ({
    //       value: item.guid,
    //       label: item.Name
    //     }))
    //   : [])
}

componentDidUpdate(prevProps, prevState) {
   if(this.state.isChannel  !== prevState.isChannel){
          return false
        }
    else if(prevState!==this.state){
      isSaveDraft=false
      if(isSaveDraft === false){
         const {
      selectedOutletProgram,selectedLocationType,selectedTier,selectedPerfectVillage,selectedChannelTts,selectedChainOutlets,
      selectedPerfectStore,selectedPerfectStoreCompliance,selectedOutleClassification,selectedRange,
      selectedPointOfConsumption,selectedLoyalityProgram,selectedCustomerAttribute,outlet_summaries,
    } = this.state;
    let myCodes = []
    if(this.props.saveOutletCodesDraft){
      this.props.saveOutletCodesDraft.forEach(elm=>myCodes.push({'guid':elm.guid,'Code':elm.Code}))
    }
    let hasCode = myCodes? myCodes:this.state.selectedExcludedOutlets
       let statedata = [{
      outet_programs:selectedOutletProgram,
      location_types:selectedLocationType,
      tiers:selectedTier,
      perfect_villages:selectedPerfectVillage,
      channel_tts:selectedChannelTts,
      chain_outlets:selectedChainOutlets,
      perfect_stores:selectedPerfectStore,
      perfect_store_compliances:selectedPerfectStoreCompliance,
      outlet_classifications:selectedOutleClassification,
      ranges:selectedRange,
      point_of_consumptions:selectedPointOfConsumption,
      loyalty_programs:selectedLoyalityProgram,
      customer_attributes:selectedCustomerAttribute,
      outlet_summaries,
      excluded_outlets:hasCode
    }];

    // For Creating select all flags
    let flagArray = [
      {
        outet_programs: selectedOutletProgram.length === 0 ? null : this.state.selectedAllOutletProgramFlag,
        location_types: selectedLocationType.length === 0 ? null : this.state.selectedAllLocationTypeFlag,
        tiers: selectedTier.length === 0 ? null : this.state.selectedAllTiersFlag,
        perfect_villages: selectedPerfectVillage.length === 0 ? null : this.state.selectedAllPerfectVillageFlag,
        // channel_tts: selectedChannelTts.length === 0 ? null : this.state.selectedAllChannelTtsFlag,      // commentted for send false value only
        channel_tts: false,
        chain_outlets: selectedChainOutlets.lengthy === 0 ? null : this.state.selectedAllChainOutletsFlag,
        perfect_stores: selectedPerfectStore.length === 0 ? null : this.state.selectedAllPerfectStoreFlag,
        perfect_store_compliances: selectedPerfectStoreCompliance.length === 0 ? null : this.state.selectedAllPerfectStoreComplianceFlag,
        outlet_classifications: selectedOutleClassification.length === 0 ? null : this.state.selectedAllOutletClassificationFlag,
        ranges: selectedRange.length === 0 ? null : this.state.selectedAllRangeFlag,
        point_of_consumptions: selectedPointOfConsumption.length === 0 ? null : this.state.selectedAllPointOfConsumptionFlag,
        loyalty_programs: selectedLoyalityProgram.length === 0 ? null : this.state.selectedAllLoyaltyProgramFlag,
        customer_attributes: selectedCustomerAttribute.length === 0 ? null : this.state.selectedAllCustomerAttributeFlag
      }
    ]

    this.saveOutletData(statedata,true)
    this.setFlagDataInDb(flagArray);
      }
      else{
        isSaveDraft=false
      }
  }
}
collapseOutletSummary=()=>{
  this.setState({
    expanded:false
  })
}


OpenOutletSummary=()=>{
  let isCodes=[]
  if(this.state.selectedExcludedOutlets){
    this.state.selectedExcludedOutlets.forEach(elm=>isCodes.push(elm.Code))
  }
  let sendCodes = isCodes.length?isCodes:this.props.outletCodes
  if(geoData.distributors){
    if(geoData.distributors.length===0 ){
      // ToastsStore.error('Distributor is mandatory for Outlet Summary!')
      CustomToast('error', 'Distributor is mandatory for Outlet Summary!')
    }else{
      if(channelData.master_channels){
        if( channelData.master_channels.length===0){
          this.setState({
            expanded:true,
            channelName:'',
            updatedOutletSummary:false
          },
          ()=>{
            this.props.get_outletSummary(
              geoData.distributors,
              channelData.sub_elements,
              this.state.channelName,
              this.state.selectedOutletProgram,
              this.state.selectedLocationType,
              this.state.selectedTier,
              this.state.selectedPerfectVillage,
              this.state.selectedChannelTts,
              this.state.selectedChainOutlets,
              this.state.selectedPerfectStore,
              this.state.selectedPerfectStoreCompliance,
              this.state.selectedOutleClassification,
              this.state.selectedRange,
              this.state.selectedPointOfConsumption,
              this.state.selectedLoyalityProgram,
              this.state.selectedCustomerAttribute,
              sendCodes
              )
          }
          )
        }else{
          if(channelData.sub_elements.length){
            this.setState({
              expanded:true,
              channelName:'sub_element',
              updatedOutletSummary:false
            },
            ()=>{
              this.props.get_outletSummary(
                geoData.distributors,
                channelData.sub_elements,
                this.state.channelName,
                this.state.selectedOutletProgram,
                this.state.selectedLocationType,
                this.state.selectedTier,
                this.state.selectedPerfectVillage,
                this.state.selectedChannelTts,
                this.state.selectedChainOutlets,
                this.state.selectedPerfectStore,
                this.state.selectedPerfectStoreCompliance,
                this.state.selectedOutleClassification,
                this.state.selectedRange,
                this.state.selectedPointOfConsumption,
                this.state.selectedLoyalityProgram,
                this.state.selectedCustomerAttribute,
                sendCodes
                )
            }
            )
          }else{
            if(channelData.elements.length){
              this.setState({
                expanded:true,
                channelName:'element',
                updatedOutletSummary:false
              },
              ()=>{
                this.props.get_outletSummary(
                  geoData.distributors,
                  channelData.elements,
                  this.state.channelName,
                  this.state.selectedOutletProgram,
                  this.state.selectedLocationType,
                  this.state.selectedTier,
                  this.state.selectedPerfectVillage,
                  this.state.selectedChannelTts,
                  this.state.selectedChainOutlets,
                  this.state.selectedPerfectStore,
                  this.state.selectedPerfectStoreCompliance,
                  this.state.selectedOutleClassification,
                  this.state.selectedRange,
                  this.state.selectedPointOfConsumption,
                  this.state.selectedLoyalityProgram,
                  this.state.selectedCustomerAttribute,
                  sendCodes
                  )
              })
            }else{
              if(channelData.channels.length){
                this.setState({
                  expanded:true,
                  channelName:'channel',
                  updatedOutletSummary:false
                },
                ()=>{
                  this.props.get_outletSummary(
                    geoData.distributors,
                    channelData.channels,
                    this.state.channelName,
                    this.state.selectedOutletProgram,
                    this.state.selectedLocationType,
                    this.state.selectedTier,
                    this.state.selectedPerfectVillage,
                    this.state.selectedChannelTts,
                    this.state.selectedChainOutlets,
                    this.state.selectedPerfectStore,
                    this.state.selectedPerfectStoreCompliance,
                    this.state.selectedOutleClassification,
                    this.state.selectedRange,
                    this.state.selectedPointOfConsumption,
                    this.state.selectedLoyalityProgram,
                    this.state.selectedCustomerAttribute,
                    sendCodes
                    )
                })
              }else{
                if(channelData.master_channels.length){
                  this.setState({
                    expanded:true,
                    channelName:'master_channel',
                    updatedOutletSummary:false
                  },
                  ()=>{
                    this.props.get_outletSummary(
                      geoData.distributors,
                      channelData.master_channels,
                      this.state.channelName,
                      this.state.selectedOutletProgram,
                      this.state.selectedLocationType,
                      this.state.selectedTier,
                      this.state.selectedPerfectVillage,
                      this.state.selectedChannelTts,
                      this.state.selectedChainOutlets,
                      this.state.selectedPerfectStore,
                      this.state.selectedPerfectStoreCompliance,
                      this.state.selectedOutleClassification,
                      this.state.selectedRange,
                      this.state.selectedPointOfConsumption,
                      this.state.selectedLoyalityProgram,
                      this.state.selectedCustomerAttribute,
                      sendCodes
                      )
                  })
                }
              }
            }
          }
        }
      }else{
        this.setState({
          expanded:true,
          channelName:'',
          updatedOutletSummary:false
        },
        ()=>{
          this.props.get_outletSummary(
            geoData.distributors,
            channelData.sub_elements,
            this.state.channelName,
            this.state.selectedOutletProgram,
            this.state.selectedLocationType,
            this.state.selectedTier,
            this.state.selectedPerfectVillage,
            this.state.selectedChannelTts,
            this.state.selectedChainOutlets,
            this.state.selectedPerfectStore,
            this.state.selectedPerfectStoreCompliance,
            this.state.selectedOutleClassification,
            this.state.selectedRange,
            this.state.selectedPointOfConsumption,
            this.state.selectedLoyalityProgram,
            this.state.selectedCustomerAttribute,
            sendCodes
            )
        }
        )
      }
    }
  }else{
    // ToastsStore.error('Distributor is mandatory for Outlet Summary!')
    CustomToast('error', 'Distributor is mandatory for Outlet Summary!')
  }
}

handleExcludedOutletPopUp = () => {
  this.setState({
    exludedOutletOpen:!this.state.exludedOutletOpen
  })
}

handleChannelData=()=>{
  if(channelData.master_channels){
    if(channelData.sub_elements.length){
      return channelData.sub_elements
    }
    else if(channelData.elements.length){
      return channelData.elements
    }
    else if(channelData.channels.length){
      return channelData.channels
    }
    else if(channelData.master_channels.length){
      return channelData.master_channels
    }
  }
}
handleUpdateSummary=(value,saveForDraft)=>{
this.setState({
  updatedOutletSummary:true
})
this.props.isUpdateSummary(value,saveForDraft)
}

  render() {
    let myCodes = []
    if(this.props.saveOutletCodesDraft){
      this.props.saveOutletCodesDraft.forEach(elm=>myCodes.push({'guid':elm.guid,'Code':elm.Code}))
    }
    let hasCode = myCodes? myCodes:this.state.selectedExcludedOutlets
    const {
      selectedOutletProgram,
      selectedLocationType,
      selectedTier,
      selectedPerfectVillage,
      selectedChannelTts,
      selectedChainOutlets,
      selectedPerfectStore,
      selectedPerfectStoreCompliance,
      selectedOutleClassification,
      selectedRange,
      selectedPointOfConsumption,
      selectedLoyalityProgram,
      selectedCustomerAttribute,
      outlet_summaries
    } = this.state;
    const {
      outletProgram,
      locationType,
      tier,
      perfectVillage,
      channelTts,
      chainOutlets,
      perfectStore,
      perfectStoreCompliance,
      outletClassification,
      range,
      pointOfConsumption,
      loyalityProgram,
      customerAttribute
    } = this.props;
    let statedata = [{
      outet_programs:selectedOutletProgram,
      location_types:selectedLocationType,
      tiers:selectedTier,
      perfect_villages:selectedPerfectVillage,
      channel_tts:selectedChannelTts,
      chain_outlets:selectedChainOutlets,
      perfect_stores:selectedPerfectStore,
      perfect_store_compliances:selectedPerfectStoreCompliance,
      outlet_classifications:selectedOutleClassification,
      ranges:selectedRange,
      point_of_consumptions:selectedPointOfConsumption,
      loyalty_programs:selectedLoyalityProgram,
      customer_attributes:selectedCustomerAttribute,
      outlet_summaries,
      excluded_outlets:hasCode
    }];
    this.props.counter!==3 ? this.saveOutletData(statedata,this.props.draft_state) : void 0;
    (this.props.counter === 3 && this.state.sync===true) || outletData.length!==0 ? this.getOutletData() : void 0
    return (
      <>
        <div>
          <div className="product_detail">
            <p>Outlet Detail</p>
          </div>
          <div
            style={(style.label, { paddingTop: "3vh", paddingBottom: "1vh" })}
          >
            <label for="prom">Outlet program</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={outletProgram ? "Outlet program" : "Loading...."}
            allowSelectAll={true}
            isMulti
            options={
              outletProgram
                ? outletProgram.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={
              outletProgram
              ? outletProgram
                  .filter(item => {
                      return !selectedOutletProgram?void 0 : selectedOutletProgram.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null    
            }
            onChange={this.programChange}
          />

          <div style={style.label}>
            <label for="prom">Location Type</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={locationType ? "Location Type" : "Loading..."}
            allowSelectAll={true}
            isMulti
            options={
              locationType
                ? locationType.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={
              locationType
              ? locationType
                  .filter(item => {
                      return !selectedLocationType?void 0 : selectedLocationType.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null    
            }
            onChange={this.locationChange}
          />

          <div style={style.label}>
            <label for="prom">Tier</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={tier ? "Tier" : "Loading..."}
            allowSelectAll={true}
            isMulti
            options={
              tier
                ? tier.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={
              tier
              ? tier
                  .filter(item => {
                      return !selectedTier?void 0 : selectedTier.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null    
            }
            onChange={this.tierChange}
          />

          <div style={style.label}>
            <label for="prom">Perfect Village</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={perfectVillage ? "Perfect Village" : "Loading..."}
            allowSelectAll={true}
            isMulti
            options={
              perfectVillage
                ? perfectVillage.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={
              perfectVillage
              ? perfectVillage
                  .filter(item => {
                      return !selectedPerfectVillage?void 0 : selectedPerfectVillage.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null    
            }
            onChange={this.villageChange}
          />

          <div style={style.label}>
            <label for="prom">Channel TTS {this.state.isChannel===true ? <span className='mandatory_fields' >
              *
              </span> :void 0}</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={ channelTts ?  "Channel TTS" : "Loading..."}
            allowSelectAll={true}
            isMulti
            options={
              channelTts?channelTts.filter(for_cat => {
                return ((this.state.category.includes('748b1a5b-5eb3-412f-8b03-fa34aea6d71b') ||
                this.state.category.includes('040af7ec-5ca5-4740-b899-9dbc48167599') ||                
                this.state.category.includes('d5b17924-d758-4f0d-b289-3c95177f10ff')) ?
                (for_cat.guid === "72181de5-4330-4116-ad70-93004e20f14f" ||                
                for_cat.guid === "6578b19d-2d67-4ae1-a14b-d9eb1e35a7c1" ||
                for_cat.guid === "82652578-87f4-462d-af65-effac29179af") : (
                  for_cat.guid === "82652578-87f4-462d-af65-effac29179af"
                ) ||
                (this.state.m_channel === '261ae803-0149-4083-9127-da216a08da83' && 
                for_cat.guid === "6e89bf6c-73dd-47f3-b0d8-bd73c73aa774" ))
                }).map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={
              channelTts
              ? channelTts
                  .filter(item => {
                      return !selectedChannelTts?void 0 : selectedChannelTts.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null    
            }
            onChange={this.channelTtsChannge}
          />

          <div style={style.label}>
            <label for="prom">Chain Outlet</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={ chainOutlets ? "Chain Outlet" : "Loading..."}
            allowSelectAll={true}
            isMulti
            options={
              chainOutlets
                ? chainOutlets.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={
              chainOutlets
              ? chainOutlets
                  .filter(item => {
                      return !selectedChainOutlets?void 0 : selectedChainOutlets.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null    
            }
            onChange={this.chainOutletChange}
          />

          <div style={style.label}>
            <label for="prom">Perfect Store</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={perfectStore ? "Perfect Store" : "Loading..."}
            allowSelectAll={true}
            isMulti
            options={
              perfectStore
                ? perfectStore.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={
              perfectStore
              ? perfectStore
                  .filter(item => {
                      return !selectedPerfectStore?void 0 : selectedPerfectStore.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null    
            }
            onChange={this.storeChange}
          />

          <div style={style.label}>
            <label for="prom">Perfect Store Compiliance</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={perfectStoreCompliance ?"Perfect Store Compiliance" : "Loading..."}
            allowSelectAll={true}
            isMulti
            options={
              perfectStoreCompliance
                ? perfectStoreCompliance.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={
              perfectStoreCompliance
              ? perfectStoreCompliance
                  .filter(item => {
                      return !selectedPerfectStoreCompliance?void 0 : selectedPerfectStoreCompliance.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null    
            }
            onChange={this.storeComplianceChange}
          />

          <div style={style.label}>
            <label for="prom">Outlet Classification</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={outletClassification ? "Outlet Classification" : "Loading.."}
            allowSelectAll={  true}
            isMulti
            options={
              outletClassification
                ? outletClassification.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={
              outletClassification
              ? outletClassification
                  .filter(item => {
                      return !selectedOutleClassification?void 0 : selectedOutleClassification.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null    
            }
            onChange={this.outletClassificationchange}
          />

          <div style={style.label}>
            <label for="prom">Range</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={range ?  "Range" : "Loading..."}
            allowSelectAll={true}
            isMulti
            options={
              range
                ? range.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={
              range
              ? range
                  .filter(item => {
                      return !selectedRange?void 0 : selectedRange.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null    
            }
            onChange={this.rangeChange}
          />

          <div style={style.label}>
            <label for="prom">Point Of Consumption</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={ pointOfConsumption ? "Point Of Consumption" : "Loading.."}
            allowSelectAll={true}
            isMulti
            options={
              pointOfConsumption
                ? pointOfConsumption.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={
              pointOfConsumption
              ? pointOfConsumption
                  .filter(item => {
                      return !selectedPointOfConsumption?void 0 : selectedPointOfConsumption.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null    
            }
            onChange={this.consumptionChange}
          />

          <div style={style.label}>
            <label for="prom">Loyalty Program</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={loyalityProgram ? "Loyalty Program" : "Loading..."}
            allowSelectAll={true}
            isMulti
            options={
              loyalityProgram
                ? loyalityProgram.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={
              loyalityProgram
              ? loyalityProgram
                  .filter(item => {
                      return !selectedLoyalityProgram?void 0 : selectedLoyalityProgram.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null    
            }
            onChange={this.loyalityChange}
          />

          <div style={style.label}>
            <label for="prom">Customer Attribute 12</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={ customerAttribute ?  "Customer Attribute 12" : "Loading..."}
            allowSelectAll={true}
            isMulti
            options={
              customerAttribute
                ? customerAttribute.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={
              customerAttribute
              ? customerAttribute
                  .filter(item => {
                      return !selectedCustomerAttribute?void 0 : selectedCustomerAttribute.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null    
            }
            onChange={this.customerAttributeChange}
          />

            <div className='outlet_summary' >
            <div className="sku_main">
                              <div className="sku_inner_body">
                                <div
                                  className="sku_content_div"
                                >
                                  <label className="sku_keys">
                                    Outlet Summary
                                  </label>
                                </div>
                              </div>

                              {this.state.expanded === true && (
                                <div >
                                  {this.props.isOutletSummaryLoading?
                                  <span>Loading...</span>
                                  :
                                  <>
                                  {this.props.excludeOutletFromSummary.excluded_outlets && this.state.updatedOutletSummary?
                                  <div className="sku_expand_body content">
                                  <div className="sku_expand_div">
                                    <table className='outlet-summary-table'>
                                      <thead className='table-header'>
                                        <th style={{textAlign:'left',padding:'1vw'}}>Region</th>
                                        <th style={{textAlign:'center',padding:'1vw'}}>Total Outlets</th>
                                        <th style={{textAlign:'right',padding:'1vw'}}>Selected</th>
                                      </thead>
                                      <tbody className='outlet-summary-table-cell'>
                                        {this.props.excludeOutletFromSummary.outlet_summary?
                                          this.props.excludeOutletFromSummary.outlet_summary.map((item,ind)=>(
                                            <tr key={ind}>
                                          <td style={{padding:'1vw'}}>
                                            {item.Name}
                                          </td>
                                          <td style={{textAlign:'center',padding:'1vw'}}>
                                            {item.total_outlets}
                                          </td>
                                          <td style={{textAlign:'right',padding:'1vw'}}>
                                            {item.selected_outlets?item.selected_outlets:item.total_outlets}
                                          </td>
                                        </tr>
                                          ))
                                        : null}
                                      </tbody>
                                    </table>
                                  </div>

                                  <div className="sku_expand_div" style={{marginTop:'16px'}}>
                                    <div className='exluded-outlet-heading-and-cta'>
                                      <div>Excluded Outlets</div>
                                      <div className='edit-cta' onClick={this.handleExcludedOutletPopUp}><u>Edit</u></div>
                                    </div>

                                  <table className='outlet-summary-table' style={{marginTop:'20px'}}>
                                    <thead className='table-header'>
                                      <th style={{textAlign:'left',padding:'1vw'}}>Outlet Code</th>
                                      <th style={{textAlign:'center',padding:'1vw'}}>Outlet Name</th>
                                      <th style={{textAlign:'right',padding:'1vw'}}>Region</th>
                                    </thead>
                                    <tbody >
                                      {this.props.excludeOutletFromSummary.excluded_outlets?
                                        this.props.excludeOutletFromSummary.excluded_outlets.map((item,ind)=>(
                                          <tr key={ind}>
                                        <td style={{padding:'1vw'}}>
                                          {item.Code}
                                        </td>
                                        <td style={{textAlign:'center',padding:'1vw'}}>
                                          {item.Description}
                                        </td>
                                        <td style={{textAlign:'right',padding:'1vw'}}>
                                          {item.Region_name}
                                        </td>
                                      </tr>
                                        ))
                                      : null}
                                    </tbody>
                                  </table>
                                  </div>
                                  </div>
                                  :
                                    <div className="sku_expand_body content">
                                  <div className="sku_expand_div">
                                    <table className='outlet-summary-table'>
                                      <thead className='table-header'>
                                        <th style={{textAlign:'left',padding:'1vw'}}>Region</th>
                                        <th style={{textAlign:'center',padding:'1vw'}}>Total Outlets</th>
                                        <th style={{textAlign:'right',padding:'1vw'}}>Selected</th>
                                      </thead>
                                      <tbody>
                                        {this.props.outletSummary.outlet_summary?
                                          this.props.outletSummary.outlet_summary.map((item,ind)=>(
                                            <tr key={ind}>
                                          <td style={{padding:'1vw'}}>
                                            {item.Name}
                                          </td>
                                          <td style={{textAlign:'center',padding:'1vw'}}>
                                            {item.total_outlets}
                                          </td>
                                          <td style={{textAlign:'right',padding:'1vw'}}>
                                            {item.selected_outlets?item.selected_outlets:item.total_outlets}
                                          </td>
                                        </tr>
                                          ))
                                        : null}
                                      </tbody>
                                    </table>
                                  </div>
                                              {/* TEMPORARY COMMENT */}
                                  {/* <div className="sku_expand_div" style={{marginTop:'16px'}}>
                                    <div className='exluded-outlet-heading-and-cta'>
                                      <div>Excluded Outlets</div>
                                      {this.props.outletSummary.excluded_outlets?this.props.outletSummary.excluded_outlets.length?
                                      <div className='edit-cta' onClick={this.handleExcludedOutletPopUp}><u>Edit</u></div>:null:null}
                                    </div>

                                    {this.props.outletSummary.excluded_outlets?this.props.outletSummary.excluded_outlets.length?
                                    <table className='outlet-summary-table' style={{marginTop:'20px'}}>
                                    <thead className='table-header'>
                                      <th style={{textAlign:'left',padding:'1vw'}}>Outlet Code</th>
                                      <th style={{textAlign:'center',padding:'1vw'}}>Outlet Name</th>
                                      <th style={{textAlign:'right',padding:'1vw'}}>Region</th>
                                    </thead>
                                    <tbody >
                                      {this.props.outletSummary.excluded_outlets?
                                        this.props.outletSummary.excluded_outlets.map((item,ind)=>(
                                          <tr key={ind}>
                                        <td style={{padding:'1vw'}}>
                                          {item.Code}
                                        </td>
                                        <td style={{textAlign:'center',padding:'1vw'}}>
                                          {item.Description}
                                        </td>
                                        <td style={{textAlign:'right',padding:'1vw'}}>
                                          {item.Region_name}
                                        </td>
                                      </tr>
                                        ))
                                      : null}
                                    </tbody>
                                  </table>:
                                  <div className='no-outlet-text'>there are no Excluded Outlets yet,
                                  <u style={{color:'#3f7fc9',cursor:'pointer'}} onClick={this.handleExcludedOutletPopUp}>click here</u> to Exclude</div>
                                  :
                                  <div className='no-outlet-text'>there are no Excluded Outlets yet,
                                  <u style={{color:'#3f7fc9',cursor:'pointer'}} onClick={this.handleExcludedOutletPopUp}>click here</u> to Exclude</div>}
                                  </div> */}
                                  </div>}
                                  </>
                                  }
                                </div>
                              )}

                              <div className="sku_right_arrow collapsible">
                                {this.state.expanded
                                ?
                                <img
                                src={require("../gt/images/arrowUp.svg")}
                                onClick={()=>this.collapseOutletSummary()}
                                alt=''
                                />
                                :
                                <img
                                src={require("../gt/images/arrowDown.svg")}
                                onClick={()=>this.OpenOutletSummary()}
                                alt=''
                                />
                              }
                              </div>
                            </div>
            </div>
        </div>
        {/* TEMPORARY COMMENT */}
        {/* {this.state.exludedOutletOpen?<ExcludeOutletPopUp isOpen={this.state.exludedOutletOpen} flagHandle={this.handleExcludedOutletPopUp} outletDetails={this.state} geoData={geoData.distributors}
              channelData={this.handleChannelData()} outletSummary={this.props.outletSummary.outlet_summary?this.props.outletSummary.outlet_summary:null} updatedData={this.handleUpdateSummary} />:null} */}
      </>
    );
  }
}

const style = {
 
  label: {
    paddingBottom: "1vh",
    paddingTop: "5.5vh",
    fontFamily: "'Source Sans Pro', sans-serif",
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.25,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#202126"
  }
};

// redux
const mapStateToProps = state => {
  return {
    outletProgram: state.OutletReducer.outletProgram,
    locationType: state.OutletReducer.locationType,
    tier: state.OutletReducer.tier,
    perfectVillage: state.OutletReducer.perfectVillage,
    channelTts: state.OutletReducer.channelTts,
    chainOutlets: state.OutletReducer.chainOutlets,
    perfectStore: state.OutletReducer.perfectStore,
    perfectStoreCompliance: state.OutletReducer.perfectStoreCompliance,
    outletClassification: state.OutletReducer.outletClassification,
    range: state.OutletReducer.range,
    pointOfConsumption: state.OutletReducer.pointOfConsumption,
    loyalityProgram: state.OutletReducer.loyalityProgram,
    customerAttribute: state.OutletReducer.customerAttribute,
    outletSummary:state.OutletReducer.outletSummary,
    isOutletSummaryLoading:state.OutletReducer.isOutletSummaryLoading,
    excludeOutletFromSummary:state.OutletReducer.excludeOutletFromSummary,
    draftData: state.CreatePromotionReducer.draftData,

  };
};

const mapDispatchToProps = dispatch => {
  return {
    get_outletProgram: () => {
      return dispatch(OutletMiddleware.get_outletProgram());
    },
    get_LocationType: () => {
      return dispatch(OutletMiddleware.get_LocationType());
    },
    get_tier: () => {
      return dispatch(OutletMiddleware.get_tier());
    },
    get_perfectVillage: () => {
      return dispatch(OutletMiddleware.get_perfectVillage());
    },
    get_channelTts: () => {
      return dispatch(OutletMiddleware.get_channelTts());
    },
    get_chainOutlets: () => {
      return dispatch(OutletMiddleware.get_chainOutlets());
    },
    get_perfectStore: () => {
      return dispatch(OutletMiddleware.get_perfectStore());
    },
    get_perfectStoreCompliance: () => {
      return dispatch(OutletMiddleware.get_perfectStoreCompliance());
    },
    get_outletClassification: () => {
      return dispatch(OutletMiddleware.get_outletClassification());
    },
    get_range: () => {
      return dispatch(OutletMiddleware.get_range());
    },
    get_pointOfConsumption: () => {
      return dispatch(OutletMiddleware.get_pointOfConsumption());
    },
    get_loyalityProgram: () => {
      return dispatch(OutletMiddleware.get_loyalityProgram());
    },
    get_customerAttribute: () => {
      return dispatch(OutletMiddleware.get_customerAttribute());
    },
    get_outletSummary: (
      geoData,
      channelData,
      channelName,
      selectedOutletProgram,
      selectedLocationType,
      selectedTier,
      selectedPerfectVillage,
      selectedChannelTts,
      selectedChainOutlets,
      selectedPerfectStore,
      selectedPerfectStoreCompliance,
      selectedOutleClassification,
      selectedRange,
      selectedPointOfConsumption,
      selectedLoyalityProgram,
      selectedCustomerAttribute,
      excludedOutletFromSummary
    ) => {
      return dispatch(OutletMiddleware.get_outletSummary(
      geoData,
      channelData,
      channelName,
      selectedOutletProgram,
      selectedLocationType,
      selectedTier,
      selectedPerfectVillage,
      selectedChannelTts,
      selectedChainOutlets,
      selectedPerfectStore,
      selectedPerfectStoreCompliance,
      selectedOutleClassification,
      selectedRange,
      selectedPointOfConsumption,
      selectedLoyalityProgram,
      selectedCustomerAttribute,
      excludedOutletFromSummary
      ));
    },
  
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Outlet);
